import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Download, Paperclip } from 'lucide-react';

const isImage = (a) => ['image/jpeg', 'image/png', 'image/webp'].includes(a.content_type);

const fetchBlobUrl = async (id) => {
  const { data } = await axios.get(`/api/admin/inquiries/files/${id}`, { responseType: 'blob' });
  return URL.createObjectURL(data);
};

const ImageThumb = ({ att }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u;
    fetchBlobUrl(att.id).then((x) => { u = x; setUrl(x); }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [att.id]);
  return (
    <a href={url || undefined} target="_blank" rel="noopener noreferrer" data-testid={`attachment-thumb-${att.id}`} title={att.filename}
      className="block w-24 h-24 rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
      {url && <img src={url} alt={att.filename} className="w-full h-full object-cover hover:scale-105 transition-transform duration-200" />}
    </a>
  );
};

const FileButton = ({ att }) => {
  const open = async () => {
    const url = await fetchBlobUrl(att.id);
    const a = document.createElement('a');
    a.href = url;
    a.download = att.filename;
    if (att.content_type === 'application/pdf') { a.target = '_blank'; a.removeAttribute('download'); }
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };
  return (
    <button onClick={open} data-testid={`attachment-file-${att.id}`}
      className="flex items-center gap-2 h-24 max-w-[12rem] px-3 rounded-lg bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-sm text-gray-800 dark:text-gray-200 hover:border-green-500">
      <FileText size={20} className="shrink-0 text-green-600" />
      <span className="truncate">{att.filename}</span>
      <Download size={14} className="shrink-0" />
    </button>
  );
};

export const InquiryAttachments = ({ attachments }) => {
  if (!attachments?.length) return null;
  return (
    <div className="mt-4" data-testid="inquiry-attachments">
      <div className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">
        <Paperclip size={14} /> Přílohy ({attachments.length})
      </div>
      <div className="flex flex-wrap gap-2">
        {attachments.map((a) => (isImage(a) ? <ImageThumb key={a.id} att={a} /> : <FileButton key={a.id} att={a} />))}
      </div>
    </div>
  );
};
